import { TypographyRebrand } from 'src/components/atoms/TypographyRebrand'
import { MemberCardRebrand } from 'src/components/molecules/MemberCardRebrand'

import { TeamMemberQueryResult } from 'src/server/router/sanity/groq/teamMembers/types'

interface MemberSectionRebrandProps {
  heading: string
  data: TeamMemberQueryResult[] | undefined
}

export const MemberSectionRebrand = ({
  data,
  heading
}: MemberSectionRebrandProps) => {
  if (!data) return null
  return (
    <div className='flex flex-col gap-4 lg:gap-8'>
      <TypographyRebrand variant='h4' color='forestDeep'>
        {heading}
      </TypographyRebrand>
      <div className='grid grid-cols-2 lg:grid-cols-4 gap-x-2 md:gap-x-4 gap-y-6 w-full'>
        {data.map(member => (
          <MemberCardRebrand key={member.name} data={member} />
        ))}
      </div>
    </div>
  )
}
